import type { Plugin } from 'vue'
import { StripeApi } from '../services/stripe'

declare module '@vue/runtime-core' {
    interface ComponentCustomProperties {
        $stripe: StripeApi,
    }
}

export const stripePlugin: Plugin = {
    install: (app, options: StripeApi.Options) => {
        app.config.globalProperties.$stripe = new StripeApi(options)
    }
}

export default defineNuxtPlugin({
    name: 'stripe-api',
    dependsOn: [
        'auth-service'
    ],
    setup(_nuxtApp) {
        const nuxtApp = useNuxtApp()
        const runtimeConfig = useRuntimeConfig()

        const stripeApiOptions: StripeApi.Options = {
            authService: nuxtApp.$auth,
            ...runtimeConfig.public.user
        }

        const stripeApi = new StripeApi(stripeApiOptions)
        return {
            provide: {
                stripe: stripeApi
            }
        }
    }
})
